


















































































import { computed, defineComponent, PropType } from 'vue';
import { SearchGroupResult } from '../../../shared/models/responses/search/findGeneric.response';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { useSearchResultGroup } from '../../composables/global_search/useSearchResultGroup';
import KeywordHighlight from 'vue-text-highlight';
import GroupMemberPopover from '../groups/GroupMemberPopover.vue';

export default defineComponent({
  name: 'SearchResultItemGroup',
  components: { GroupMemberPopover, Icon, KeywordHighlight },
  props: {
    group: {
      type: Object as PropType<SearchGroupResult>,
      required: true,
    },
    searchString: { type: String, default: '' },
  },
  setup(props) {
    const {
      action,
      isLoading,
      isVisibleInstitutionSelection,
      institutionSelectModalTitle,
      institutionSelectModalDescription,
      institutionSelectModalButtonLabel,
      selectedInstitutionProfileId,
      applicableInstitutions,
      canViewGroupMembership,
      showInstitutionSelection,
      handleGroupAction,
      openGroup,
      joinOrLeaveGroup,
    } = useSearchResultGroup({
      group: computed(() => props.group),
      searchString: computed(() => props.searchString),
    });

    return {
      action,
      isLoading,
      isVisibleInstitutionSelection,
      institutionSelectModalTitle,
      institutionSelectModalDescription,
      institutionSelectModalButtonLabel,
      selectedInstitutionProfileId,
      applicableInstitutions,
      canViewGroupMembership,
      showInstitutionSelection,
      openGroup,
      handleGroupAction,
      joinOrLeaveGroup,
      iconClassEnum,
    };
  },
});
